import client from "../client"

const URL = "https://ufoodapi.herokuapp.com";

export default {
  postUserVisit: async (token,userId) => {
    return await client.post(`/users/${userId}/restaurants/visits`, token)
  }

}
export const getUser = async (userToken) => {
  const response = await fetch(`${URL}/users/${userToken.id}`,{
    headers: {
      'Authorization': userToken.token
    },
  })
  return await response.json()
}

export const getUsers = async (userToken) => {
  const response = await fetch(`${URL}/users?limit=100`,{
    headers: {
      'Authorization': userToken.token
    },
  })
  return await response.json()
}
